const appTheme = {
	primaryColor: '#D53B47',
	secondaryColor: '#2B2A2C',
	primaryTextColor: '#FFFFFF',
	buttonHighlightColor: '#d6515c',
	primaryFontFamily: 'Inter, Roboto, default'
}

export default appTheme
